// extracted by mini-css-extract-plugin
module.exports = {"arrow":"PopperArrow_arrow__2Xl9a"};